import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NetworkStatusService } from '@shared/services/network-status.service';
import { SourceIconComponent } from '@shared/components/source-icon/source-icon.component';

@Component({
  selector: 'app-network-status',
  templateUrl: 'network-status.component.html',
  styleUrl: 'network-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SourceIconComponent],
})
export class NetworkStatusComponent {
  isOffline = inject(NetworkStatusService).isOffline;
}
